import MESSAGES from '../messages';

export const mappingTypeOptions = [
    {
        value: 'AGGREGATE',
        label: MESSAGES.aggregate,
    },
    {
        value: 'EVENT',
        label: MESSAGES.event,
    },
    {
        value: 'EVENT_TRACKER',
        label: MESSAGES.eventTracker,
    },
];
